import * as React from "react";

import { useSelector } from 'react-redux';
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";


import {
  makeStyles
}
  from "@mui/styles";

import { dateToInputString } from "../utils";

const useStyles = makeStyles(theme => ({
  textarea: {
    resize: "both"
  }
}));



export default function AgencyActionsGrid(props) {
  const pictures = useSelector((state) => state.data.pictures);
  const classes = useStyles();
  const { actions, currentAction, setActions, promotyp, promoclass, onpage, hotellists } =
    props;
  let propertiesParseable = false;
  if (
    currentAction?.properties &&
    currentAction.properties instanceof Object &&
    JSON.stringify(currentAction.properties).indexOf("{") === 0
  ) {
    propertiesParseable = true;
  }

  let stylesParseable = false;
  if (
    currentAction?.properties?.styles &&
    currentAction.properties instanceof Object &&
    JSON.stringify(currentAction.properties.styles).indexOf("{") === 0
  ) {
    stylesParseable = true;
  }


  let stickertimeParseable = false;
  if (
    currentAction?.properties?.stickertime &&
    currentAction.properties instanceof Object &&
    JSON.stringify(currentAction.properties.stickertime).indexOf("{") === 0
  ) {
    stickertimeParseable = true;
  }


  return (
    <Paper style={{ padding: 16 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={1}>
          <TextField
            fullWidth
            label="rank"
            value={currentAction.rank ? currentAction.rank : ""}
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    rank: evt.target.value,
                    dirty: true,
                  }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            label="code"
            value={currentAction.code ? currentAction.code : ""}
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? { ...ele, code: evt.target.value, dirty: true }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="label  (MarketingBox)"
            value={currentAction.label ? currentAction.label : ""}
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? { ...ele, label: evt.target.value, dirty: true }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            label="actioncode"
            value={
              currentAction.properties
                ? currentAction.properties.actioncode
                  ? currentAction.properties.actioncode
                  : ""
                : ""
            }
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    properties: {
                      ...ele.properties,
                      actioncode: evt.target.value,
                    },
                    dirty: true,
                  }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            label="actiongroup  ( same group customer must choice )"
            value={currentAction.actiongroup ? currentAction.actiongroup : ""}
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? { ...ele, actiongroup: evt.target.value, dirty: true }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="text (Hotel Voucher)"
            value={
              currentAction.properties
                ? currentAction.properties.text
                  ? currentAction.properties.text
                  : ""
                : ""
            }
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    properties: {
                      ...ele.properties,
                      text: evt.target.value,
                    },
                    dirty: true,
                  }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            label="description (booking form)"
            value={
              currentAction.properties
                ? currentAction.properties.description
                  ? currentAction.properties.description
                  : ""
                : ""
            }
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    properties: {
                      ...ele.properties,
                      description: evt.target.value,
                    },
                    dirty: true,
                  }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            multiline
            rows={2}
            label="mouseover"
            value={
              currentAction.properties
                ? currentAction.properties.mouseover
                  ? currentAction.properties.mouseover
                  : ""
                : ""
            }
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    properties: {
                      ...ele.properties,
                      mouseover: evt.target.value,
                    },
                    dirty: true,
                  }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            label="bookingFrom"
            type="date"
            value={
              currentAction.booking_from
                ? dateToInputString(currentAction.booking_from)
                : ""
            }
            onKeyDown={(e) => e.preventDefault()}
            onChange={(evt) => {
              try {
                let tmp = new Date(evt.target.value);
                let act = actions.map((ele) =>
                  ele.id === currentAction.id
                    ? {
                      ...ele,
                      booking_from: tmp,
                      dirty: true,
                    }
                    : ele
                );
                setActions(act);
              } catch (e) { }
            }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            label="bookingUntil"
            type="date"
            value={
              currentAction.booking_until
                ? dateToInputString(currentAction.booking_until)
                : ""
            }
            onKeyDown={(e) => e.preventDefault()}
            onChange={(evt) => {
              try {
                let tmp = new Date(evt.target.value);
                let act = actions.map((ele) =>
                  ele.id === currentAction.id
                    ? {
                      ...ele,
                      booking_until: tmp,
                      dirty: true,
                    }
                    : ele
                );
                setActions(act);
              } catch (e) { }
            }}
          />
        </Grid>

        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            label="usingFrom"
            type="date"
            value={
              currentAction.using_from
                ? dateToInputString(currentAction.using_from)
                : ""
            }
            onKeyDown={(e) => e.preventDefault()}
            onChange={(evt) => {
              try {
                let tmp = new Date(evt.target.value);
                let act = actions.map((ele) =>
                  ele.id === currentAction.id
                    ? {
                      ...ele,
                      using_from: tmp,
                      dirty: true,
                    }
                    : ele
                );
                setActions(act);
              } catch (e) { }
            }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            label="usingUntil"
            type="date"
            value={
              currentAction.using_until
                ? dateToInputString(currentAction.using_until)
                : ""
            }
            onKeyDown={(e) => e.preventDefault()}
            onChange={(evt) => {
              try {
                let tmp = new Date(evt.target.value);
                let act = actions.map((ele) =>
                  ele.id === currentAction.id
                    ? {
                      ...ele,
                      using_until: tmp,
                      dirty: true,
                    }
                    : ele
                );
                setActions(act);
              } catch (e) { }
            }}
          />
        </Grid>

        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            label="validFrom"
            type="date"
            value={
              currentAction.valid_from
                ? dateToInputString(currentAction.valid_from)
                : ""
            }
            onKeyDown={(e) => e.preventDefault()}
            onChange={(evt) => {
              try {
                let tmp = new Date(evt.target.value);
                let act = actions.map((ele) =>
                  ele.id === currentAction.id
                    ? {
                      ...ele,
                      valid_from: tmp,
                      dirty: true,
                    }
                    : ele
                );
                setActions(act);
              } catch (e) { }
            }}
          />
        </Grid>

        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            label="validUntil"
            type="date"
            value={
              currentAction.valid_until
                ? dateToInputString(currentAction.valid_until)
                : ""
            }
            onKeyDown={(e) => e.preventDefault()}
            onChange={(evt) => {
              try {
                let tmp = new Date(evt.target.value);
                let act = actions.map((ele) =>
                  ele.id === currentAction.id
                    ? {
                      ...ele,
                      valid_until: tmp,
                      dirty: true,
                    }
                    : ele
                );
                setActions(act);
              } catch (e) { }
            }}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            multiline
            rows={2}
            label="condition"
            inputProps={{ className: classes.textarea }}
            value={currentAction.condition ? currentAction.condition : ""}
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    condition: evt.target.value,
                    dirty: true,
                  }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            multiline
            rows={2}
            label="pricerange ( > x , < x , between x and y )"
            value={currentAction.pricerange ? currentAction.pricerange : ""}
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    pricerange: evt.target.value,
                    dirty: true,
                  }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            multiline
            rows={2}
            label="touroperators (comma sperated list e.g. 'DER','TUI')"
            value={
              currentAction.touroperators ? currentAction.touroperators : ""
            }
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    touroperators: evt.target.value,
                    dirty: true,
                  }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            multiline
            rows={2}
            label="departures (comma sperated list e.g. 'HAM','BER')"
            value={
              currentAction.departures ? currentAction.departures : ""
            }
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    departures: evt.target.value,
                    dirty: true,
                  }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            multiline
            rows={2}
            label="destinations (comma sperated list e.g. 'ATY','KXZ')"
            value={
              currentAction.destinations ? currentAction.destinations : ""
            }
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    destinations: evt.target.value,
                    dirty: true,
                  }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={1}>
          <FormControl fullWidth>
            <InputLabel id="select-typesl">PromoTyp</InputLabel>
            <Select
              fullWidth
              labelId="select-typesl"
              id="select-types"
              value={
                currentAction.properties
                  ? currentAction.properties.typ
                    ? currentAction.properties.typ
                    : ""
                  : ""
              }
              variant="standard"
              onChange={(evt) => {
                let act = actions.map((ele) =>
                  ele.id === currentAction.id
                    ? {
                      ...ele,
                      properties: {
                        ...ele.properties,
                        typ: evt.target.value,
                      },
                      dirty: true,
                    }
                    : ele
                );
                setActions(act);
              }}
            >
              {promotyp.map((o) => (
                <MenuItem key={o.propertyid} value={o.propertyid}>
                  {o.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      
        <Grid item xs={12} md={2}>
          <FormControl fullWidth>
            <InputLabel id="select-typid">Plazierung</InputLabel>
            <Select
              fullWidth
              labelId="select-onpage"
              id="select-onpage"
              value={currentAction.onpage ? currentAction.onpage : ""}
              variant="standard"
              onChange={(evt) => {
                let act = actions.map((ele) =>
                  ele.id === currentAction.id
                    ? {
                      ...ele,

                      onpage: evt.target.value,
                      dirty: true,
                    }
                    : ele
                );
                setActions(act);
              }}
            >
              {onpage.map((o) => (
                <MenuItem key={o.propertyid} value={o.propertyid}>
                  {o.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={2}>
          <InputLabel id="select-typid">Sticker</InputLabel>
          <Select
            fullWidth
            labelId="select-typesl"
            id="select-types"
            value={
              currentAction.sticker ? currentAction.sticker : ""
            }
            variant="standard"

            onChange={(evt) => {
              let act = actions.map((ele, i) => {
                if (ele.id === currentAction.id) {
                  return {
                    ...ele,
                    sticker: evt.target.value,
                    dirty: true
                  };
                } else {
                  return ele;
                }
              });
              setActions(act);
            }}
          >
            {(Array.isArray(pictures[currentAction.folderid]) ? pictures[currentAction.folderid] : []).map((o) => (
              <MenuItem key={o.url} value={o.url}>
                {o.filename}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} md={1}>
          <TextField
            fullWidth
            label="stickerpos (1-9="
            value={currentAction.properties.stickerpos ? currentAction.properties.stickerpos : ""}
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    properties: {
                      ...ele.properties,
                      stickerpos: JSON.parse(evt.target.value),
                    },
                    dirty: true,
                  }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            style={{
              backgroundColor: stickertimeParseable ? undefined : "#ffaaaa",
            }}
            fullWidth
            multiline
            inputProps={{ className: classes.textarea }}
            rows={2}
            label="stickertime"
            value={
              currentAction.properties.stickertime
                ? stickertimeParseable
                  ? JSON.stringify(currentAction.properties.stickertime, null, 8)
                  : currentAction.properties.stickertime
                : ""
            }


            onChange={(evt) => {
              let act = actions.map((ele) => {
                try {
                  return (ele.id === currentAction.id
                    ? {
                      ...ele,
                      properties: {
                        ...ele.properties,
                        stickertime: JSON.parse(evt.target.value),
                      },
                      dirty: true,
                    }
                    : ele)
                }
                catch (e) {
                  return (ele.id === currentAction.id
                    ? {
                      ...ele,
                      properties: {
                        ...ele.properties,
                        stickertime: evt.target.value,
                      }
                    }
                    : ele)
                }
              }

              );
              setActions(act);

            }}
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <FormControl fullWidth>
            <InputLabel id="select-listid">Hotellist</InputLabel>
            <Select
              fullWidth
              labelId="select-listid"
              id="select-list-id"
              value={currentAction.hotellistid ? currentAction.hotellistid : ""}
              variant="standard"
              onChange={(evt) => {
                let act = actions.map((ele) =>
                  ele.id === currentAction.id
                    ? {
                      ...ele,

                      hotellistid: evt.target.value,
                      dirty: true,
                    }
                    : ele
                );
                setActions(act);
              }}
            >
              {hotellists.map((o) => (
                <MenuItem key={o.id} value={o.id}>
                  {o.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={2}>
          <TextField
            fullWidth
            label="retention (x hour, x day)"
            value={currentAction.retention ? currentAction.retention : ""}
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    retention: evt.target.value,
                    dirty: true,
                  }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            multiline
            inputProps={{ className: classes.textarea }}
            label="style"
            style={{
              backgroundColor: stylesParseable ? undefined : "#ffaaaa",
            }}
            value={
              currentAction.properties.styles
                ? stylesParseable
                  ? JSON.stringify(currentAction.properties.styles, null, 8)
                  : currentAction.properties.styles
                : ""
            }

            onChange={(evt) => {

              let a = "";
              try {
                a = JSON.parse(evt.target.value);
              } catch (e) {
                a = evt.target.value;
              }

              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    properties: {
                      ...ele.properties,
                      styles: a
                    },
                    dirty: true,
                  }
                  : ele
              );
              console.log(act);
              setActions(act);
            }}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            multiline
            rows={3}
            label={`cashback condition (case when price > 1000 then '{"text":"75 Euro Cashback","coupon":"DERSUMMER75","value":75} ... else '{}' end'`}
            inputProps={{ className: classes.textarea }}
            value={currentAction.varcondition ? currentAction.varcondition : ""}
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    varcondition: evt.target.value,
                    dirty: true,
                  }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            multiline
            rows={3}
            label="condition htmltext"
            inputProps={{ className: classes.textarea }}
            value={currentAction.conditionhtmltext ? currentAction.conditionhtmltext : ""}
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    conditionhtmltext: evt.target.value,
                    dirty: true,
                  }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            multiline
            rows={2}
            label="request"
            value={currentAction.request ? currentAction.request : ""}
            onChange={(evt) => {
              let act = actions.map((ele) =>
                ele.id === currentAction.id
                  ? {
                    ...ele,
                    request: evt.target.value,
                    dirty: true,
                  }
                  : ele
              );
              setActions(act);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          {currentAction.errormsg}
        </Grid>
      </Grid>
    </Paper>
  );
}
